export default __webpack_public_path__ + "static/media/Trashaus-left.b88a2d8f.png";